import * as React from 'react';
import * as styles from './layout.module.scss';
import Header from '../header';
import Footer from '../footer';

const Layout = (props) => {

  return (
    <>
      <a href="#main-content" id="skip-nav">Skip to main content</a>
      <Header headerClassName={props.headerClassName} />
      <main id="main-content" className={styles.mainContent}>
        {props.children}
      </main>
      <Footer />
    </>
  );
}

export default Layout;